module.exports = __webpack_public_path__ + "img/master-layout.37c43ace.jpg";